<template>
  <div>
    <small class="text-muted">Mostrar solo de tipo : </small>
    <b-button
      v-for="{ id, nivel } in data"
      :key="id"
      :variant="selected === id ? 'secondary' : 'primary'"
      class="mr-75"
      size="sm"
      @click="() => handleClick(id)"
    >
      <feather-icon
        v-if="selected === id"
        icon="CheckIcon"
        class="mr-50"
      />
      {{ nivel }}
    </b-button>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import getNivelAcademicoCatalogo from './useFiltroNivelAcademico'

export default {
  components: {
    BButton,
  },
  setup(_, { emit }) {
    const toast = useToast()
    const seachString = ref('')
    const loader = ref(false)
    const data = ref([])
    const selected = ref(null)

    const fetchData = async () => {
      try {
        loader.value = true
        const result = await getNivelAcademicoCatalogo()

        data.value = result
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en solicitud [nivel académico]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      } finally {
        loader.value = false
      }
    }

    const handleClick = id => {
      if (selected.value === id) {
        emit('item-selected', null)
        selected.value = null
        return
      }

      emit('item-selected', id)

      selected.value = id
    }

    onMounted(() => fetchData())

    return {
      loader,
      seachString,
      selected,
      data,

      handleClick,
    }
  },
}
</script>
